module.exports = __webpack_public_path__ + "static/img/ic_zoom_in.1784115679763.png";